/* Talk to Group Sales modal: choose (book a call / call back), meeting scheduler, call-back form.
   Loads before sfg-group.js, which opens and closes #sfg-modal. */
(function () {
  var C = window.SFG || {};
  function track(ev) { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: ev }); }
  function $(id) { return document.getElementById(id); }
  var framed = false;
  function show(view) {
    var m = $('sfg-modal'); if (!m) return;
    ['sfg-thanks', 'sfg-small'].forEach(function (id) { var t = $(id); if (t) t.classList.remove('is-on'); });
    var w = $('sfg-formwrap'); if (w) w.style.display = '';
    m.setAttribute('data-show', view);
    if (view === 'meet') {
      track('group_meeting_open');
      if (C.meetingUrl && !framed) {
        framed = true;
        var f = document.createElement('iframe');
        f.src = C.meetingUrl + (C.meetingUrl.indexOf('?') > -1 ? '&' : '?') + 'embed=true';
        f.title = 'Book a 15-minute call'; f.loading = 'lazy';
        var box = $('sfg-meetframe'); box.innerHTML = ''; box.appendChild(f);
      }
    }
    if (view === 'callback') track('group_callback_open');
    setTimeout(function () {
      var v = m.querySelector('[data-view="' + view + '"]');
      var el = v && v.querySelector(view === 'callback' ? 'input' : 'button'); if (el) el.focus();
    }, 60);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var b = t.closest('[data-sfg-meet],[data-sfg-callback],[data-sfg-back],[data-sfg-open]'); if (!b) return;
    if (b.hasAttribute('data-sfg-meet')) show('meet');
    else if (b.hasAttribute('data-sfg-callback')) show('callback');
    else show('choose');
    /* buttons inside the modal only switch views; page buttons also carry data-sfg-open so sfg-group.js opens the modal */
  }, true);
  window.addEventListener('message', function (e) { if (e.data && e.data.meetingBookSucceeded) track('group_meeting_booked'); });
})();
/* Stockist map search: "postcode" -> "zip code" */
(function () {
  var TXT = 'Type a zip code or address...';
  function fix() {
    var box = document.getElementById('sfg-locations'); if (!box) return;
    box.querySelectorAll('input.stockist-search-field').forEach(function (i) {
      if (i.placeholder !== TXT) { i.placeholder = TXT; i.setAttribute('aria-label', TXT); }
    });
  }
  function start() {
    var box = document.getElementById('sfg-locations'); if (!box) return;
    fix(); new MutationObserver(fix).observe(box, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* eCard images: tap or click to see a card larger */
(function () {
  function start() {
    var row = document.querySelector('#sfg .sfg-cards__row'); if (!row) return;
    var cap = document.querySelector('#sfg .sfg-cards > p');
    if (cap && !cap.querySelector('.sfg-cards__hint')) cap.insertAdjacentHTML('beforeend', ' <span class="sfg-cards__hint">Tap a card to enlarge</span>');
    var box = document.createElement('div');
    box.className = 'sfg-zoom'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'eCard preview'); box.hidden = true;
    box.innerHTML = '<button type="button" class="sfg-zoom__x" aria-label="Close">&times;</button><img alt=""><p class="sfg-zoom__cap"></p>';
    (document.getElementById('sfg') || document.body).appendChild(box);
    var big = box.querySelector('img'), capEl = box.querySelector('.sfg-zoom__cap'), last = null;
    function close() { box.hidden = true; document.documentElement.classList.remove('sfg-noscroll'); if (last) last.focus(); }
    row.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('tabindex', '0'); img.setAttribute('role', 'button');
      img.setAttribute('aria-label', 'Enlarge ' + (img.alt || 'eCard'));
      function open() {
        last = img; big.src = img.src.replace(/width=\d+/, 'width=1200'); big.alt = img.alt; capEl.textContent = img.alt;
        box.hidden = false; document.documentElement.classList.add('sfg-noscroll'); box.querySelector('.sfg-zoom__x').focus();
        window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'group_card_zoom', card: img.alt });
      }
      img.addEventListener('click', open);
      img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
    box.addEventListener('click', function (e) { if (e.target !== big) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* Deep links: ...#book-a-call opens the scheduler, ...#call-back opens the call-back form (used by the chatbot) */
(function () {
  function go() {
    var h = (location.hash || '').toLowerCase(), sel = null;
    if (h === '#book-a-call') sel = '#sfg-sales [data-sfg-meet]';
    else if (h === '#call-back') sel = '#sfg-sales [data-sfg-callback]';
    if (!sel) return;
    var b = document.querySelector(sel); if (b) b.click();
  }
  window.addEventListener('hashchange', go);
  window.addEventListener('load', function () { setTimeout(go, 300); });
})();
